<template>
  <main>
    <main-header />
    <div class="no-auth">
      <router-view />
    </div>
    <main-footer />
  </main>
</template>

<script>
import MainFooter from "@/components/MainFooter.vue";
import MainHeader from "@/components/MainHeader.vue";
export default {
  components: {
    MainHeader,
    MainFooter,
  },
};
</script>